import styles from 'components/Layout.module.css';
import {TopNavbar} from 'components/TopNavbar';

type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({children}: LayoutProps) => {
  return (
    <>
      <TopNavbar />
      <div className={styles.container}>{children}</div>
    </>
  );
};

export {Layout};
